import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Button } from './Button';
import { NAV_LINKS, LOGO_DARK } from '../data/site';
interface MobileNavProps {
  open: boolean;
  onClose: () => void;
  onDownload: () => void;
}
export function MobileNav({
  open,
  onClose,
  onDownload
}: MobileNavProps) {
  return <AnimatePresence data-id="element-115">
      {open && <>
          <motion.div className="fixed inset-0 z-50 bg-charcoal/40 lg:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} aria-hidden data-id="element-116" />
          <motion.div className="fixed inset-y-0 right-0 z-50 flex w-[82%] max-w-sm flex-col bg-cream px-6 py-5 lg:hidden" initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.28,
        ease: 'easeOut'
      }} role="dialog" aria-label="Site menu" data-id="element-117">
            <div className="flex items-center justify-between" data-id="element-118">
              <Link to="/" onClick={onClose} aria-label="Mine Geology Systems — home" data-id="element-119">
                <img src={LOGO_DARK} alt="Mine Geology Systems" className="h-7 w-auto" data-id="element-120" />
              </Link>
              <button type="button" onClick={onClose} aria-label="Close menu" className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-charcoal/15 text-charcoal hover:bg-charcoal/5" data-id="element-121">
                <XIcon className="h-5 w-5" data-id="element-122" />
              </button>
            </div>

            <nav aria-label="Mobile" className="mt-10 flex flex-col gap-1" data-id="element-123">
              {NAV_LINKS.map(link => <NavLink key={link.href} to={link.href} onClick={onClose} className={({
            isActive
          }) => `rounded-md px-3 py-3 text-lg font-medium hover:bg-charcoal/5 ${isActive ? 'font-bold text-charcoal underline decoration-yellow decoration-2 underline-offset-4' : 'text-charcoal'}`} data-id="element-124">
                  {link.label}
                </NavLink>)}
            </nav>

            <div className="mt-auto" data-id="element-125">
              <Button variant="primary" onClick={onDownload} className="w-full" data-id="element-126">
                Download Free Guide
              </Button>
              <p className="mt-3 text-center text-xs text-warmgray" data-id="element-127">
                No spam. Practical field notes only.
              </p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}